import * as types from '../constants/actionTypes';
import initialState from '../store/initialState';

export default function snackbarReducer(state = initialState.snackbars, action) {
    switch(action.type) {
        case types.ADD_SNACKBAR:
            return {...state, items: [...state.items, action.payload.snackbar]};
        case types.REMOVE_SNACKBAR: {
            return {...state, items: state.items.filter(r => r.id !== action.payload.id)};
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/snackbarReducer.js